import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { Modal, Button } from 'react-bootstrap';
import { CheckCircle } from 'react-bootstrap-icons'; // Bootstrap Icons

export default function ContactForm() {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  // Handler for input field changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    // EmailJS parameters
    const serviceID = 'service_1fxtfvj';
    const templateID = 'template_i31tijj';
    const publicKey = 'uWbAH2Vg-LbnNu4eh';

    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      subject: formData.subject,
      message: formData.message,
    };

    emailjs
      .send(serviceID, templateID, templateParams, publicKey)
      .then((response) => {
        console.log('Email sent successfully:', response);
        setFormData({ name: '', email: '', subject: '', message: '' });
        setLoading(false);
        setShowModal(true); // Show popup when message is sent
      })
      .catch((error) => {
        console.error('Error sending email:', error);
        setLoading(false);
        alert('Failed to send the message. Please try again later.');
      });
  };

  return (
    <>
      <form id="contact-form" onSubmit={onSubmit}>
        <div className="row gx-3 gy-4">
          <div className="col-md-6">
            <div className="form-group">
              <label className="form-label">Your Name</label>
              <input
                name="name"
                placeholder="Name *"
                className="form-control"
                type="text"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label className="form-label">Your Email</label>
              <input
                name="email"
                placeholder="Email *"
                className="form-control"
                type="email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label className="form-label">Subject</label>
              <input
                name="subject"
                placeholder="Subject *"
                className="form-control"
                type="text"
                value={formData.subject}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-group">
              <label className="form-label">Your message</label>
              <textarea
                name="message"
                placeholder="Your message *"
                rows={4}
                className="form-control"
                value={formData.message}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="send">
              <button
                className={`px-btn w-100 ${loading ? 'disabled' : ''}`}
                type="submit"
                disabled={loading}
              >
                {loading ? 'Sending...' : 'Send Message'}
              </button>
            </div>
          </div>
        </div>
      </form>

      {/* Success Message Popup (Elegant Modal) */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <div style={styles.modalContent}>
          {/* Close Button */}
          <button style={styles.closeButton} onClick={() => setShowModal(false)}>
            ✕
          </button>

          {/* Success Icon */}
          <CheckCircle style={styles.successIcon} />

          {/* Title */}
          <h4 style={styles.title}>Success</h4>

          {/* Message */}
          <p style={styles.message}>
            Your message has been sent successfully. We will get back to you soon.
          </p>

          {/* OK Button */}
          <Button style={styles.okButton} onClick={() => setShowModal(false)}>
            OK
          </Button>
        </div>
      </Modal>
    </>
  );
}

// Styles
const styles = {
  modalContent: {
    borderRadius: "15px",
    textAlign: "center",
    padding: "30px",
    border: "none",
    backgroundColor: "#fff",  
    boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.2)",
    position: "relative",
    width: "100%",
    maxWidth: "400px",
    margin: "auto",
  },
  closeButton: {
    position: "absolute",
    top: "12px",
    right: "18px",
    background: "none",
    border: "none",
    fontSize: "22px",
    cursor: "pointer",
    opacity: "0.6",
  },
  successIcon: {
    fontSize: "55px",
    color: "#0788FF",
    marginBottom: "15px",
  },
  title: {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#000",
    marginBottom: "12px",
  },
  message: {
    color: "#555",
    fontSize: "16px",
    marginBottom: "20px",
    lineHeight: "1.5",
  },
  okButton: {
    backgroundColor: "#0788FF",
    border: "none",
    width: "100%",
    padding: "12px",
    fontSize: "16px",
    fontWeight: "bold",
    borderRadius: "8px",
  },
};
